const axios = require("axios").default;

const URL_INVOICE = `${process.env.REACT_APP_API_URL}/invoice`;
const URL_BATCH = `${process.env.REACT_APP_API_URL}/batch/onfly`;
const URL_MATERIAL = `${process.env.REACT_APP_API_URL}/material`;
const URL_PARAM = `${process.env.REACT_APP_API_URL}/param`;
const URL_CUSTOMER = `${process.env.REACT_APP_API_URL}/customer`;
const URL_RETURN = `${process.env.REACT_APP_API_URL}/return`;
const URL_RETURN_RB = `${process.env.REACT_APP_API_URL}/rb-return`;

// export const getInvoice = (payload) => {
//   return axios.get(URL_INVOICE, {
//     params: payload,
//   });
// };

export const getInvoice = (payload) => {
  return axios
    .get(URL_INVOICE, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const getBatch = (payload) => {
  return axios
    .get(URL_BATCH, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const getMaterial = (payload) => {
  return axios.get(URL_MATERIAL, {
    params: payload,
  });
};

export const getParam = (payload) => {
  return axios.get(URL_PARAM, {
    params: payload,
  });
};

export const getCustomer = (payload) => {
  return axios.get(URL_CUSTOMER, {
    params: payload,
  });
};

// export const postApproval = (payload) => {
//   return axios.post(URL_RETURN, payload);
// };

export const postApproval = (payload) => {
  return axios.post(`${URL_RETURN}`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updateDraft = (payload, id) => {
  return axios.put(`${URL_RETURN}/${id}`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

// export const postAttch = (retNumber) => {
//   return axios.post(`${URL_RETURN}/attachment`);
// };

export const postFile = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(`${URL_RETURN}/attachment`, formData);
};

export const getFile = (fileID = null) => {
  return axios.get(`${URL_RETURN}/attachment/${fileID}`);
};
